module.exports = __webpack_public_path__ + "static/media/onboarding-person-2.fab61982.jpg";